import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import * as ar from '../../../assets/i18n/ar.json';
import * as en from '../../../assets/i18n/en.json';
import { DEFAULT_LANGUAGE } from './supported-languages';

type TranslationTree = Record<string, unknown>;

const TRANSLATIONS: Record<string, TranslationTree> = {
  en: en as TranslationTree,
  ar: ar as TranslationTree,
};

/** Loads locale files bundled at build time (no HttpClient / API prefix). */
export class LocalTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<TranslationTree> {
    return of(TRANSLATIONS[lang] ?? TRANSLATIONS[DEFAULT_LANGUAGE]);
  }
}

export function localTranslateLoaderFactory(): TranslateLoader {
  return new LocalTranslateLoader();
}
